
import { Component, Emit, Prop, Mixins } from "vue-property-decorator"
import api from "../../honcierge-api"
import ProcessingMixin from "../../mixins/processing-mixin"
import { AdminUser } from "types/adminUser"

@Component
export default class AdminUserSearchForm extends Mixins(ProcessingMixin) {
  @Prop()
  private role!: string
  @Prop()
  private roleName!: string
  @Prop({ default: true })
  private enableName!: boolean

  private totalPages = 0
  private pagination = {
    sortBy: ["id"],
    sortDesc: [true],
    itemsPerPage: -1,
    page: 1,
  }
  private name = ""
  private result: AdminUser["data"][] = []
  @Emit("resetPagination")
  public emitResetPagination(): void {
    /* */
  }
  @Emit("resetSelection")
  public emitResetSelection(): void {
    /* */
  }

  @Emit("searchResult")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private searchResult(result: AdminUser["data"][], totalPages: number) {
    /* */
  }

  public reset() {
    this.name = ""
    this.result = []
  }

  public async search(page = 1, sortBy = "id", descending = false) {
    this.startProcess()
    try {
      const response = await api.getAdminUsers(
        this.role,
        this.name,
        page,
        10,
        sortBy,
        descending
      )
      this.result = response.data.adminUsers
      this.searchResult(
        response.data.adminUsers.length > 0 ? this.result : [],
        response.data.meta.totalPages
      )
    } catch {
      this.$toasted.error(`${this.roleName}の取得に失敗しました`)
    } finally {
      this.endProcess()
    }
  }
}
